var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 18,
    viewBox: "0 0 136 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_7969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.546V2.55345C18.546 2.83157 18.4321 3.0983 18.2293 3.29496C18.0264 3.49162 17.7514 3.6021 17.4645 3.6021H3.70964V7.19371H18.546V17.9885H1.08153C0.794689 17.9885 0.519598 17.878 0.316772 17.6813C0.113946 17.4847 0 17.2179 0 16.9398L0 14.3864H14.8375V10.7906H0V0Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2577 3.6021L22.2534 0H40.8005V3.6021H22.2577Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8223 14.3914V16.9511C40.8223 17.2293 40.7083 17.496 40.5055 17.6926C40.3027 17.8893 40.0276 17.9998 39.7407 17.9998H22.2795L22.2676 7.19873H40.8006V10.7956H25.9567V14.3924L40.8223 14.3914Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5125 3.6021L44.5082 0H63.0553V3.6021H44.5125Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0768 14.3914V16.9511C63.0768 17.2293 62.9629 17.496 62.7601 17.6926C62.5572 17.8893 62.2821 17.9998 61.9953 17.9998H44.5286L44.5167 7.19873H63.053V10.7956H48.2091V14.3924L63.0768 14.3914Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.563 0H89.0173V17.999H105.941C106.371 17.999 106.784 17.8332 107.088 17.5382C107.392 17.2433 107.563 16.8432 107.563 16.426V10.7906L105.709 8.99214L107.563 7.19266V0ZM103.854 14.3864H92.7259V10.7906H103.854V14.3864ZM103.854 7.19371H92.7259V3.59685H103.854V7.19371Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.272 0H114.982V17.9885H112.894C112.464 17.9885 112.051 17.8227 111.747 17.5278C111.443 17.2328 111.272 16.8327 111.272 16.4155V0Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.454 0H136V3.59685H128.582V17.9885H126.494C126.064 17.9885 125.652 17.8227 125.347 17.5278C125.043 17.2328 124.872 16.8327 124.872 16.4155V3.59685H117.454V0Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7627 0V3.59685H81.6002V7.19371H66.7627V17.9885H69.3908C69.6776 17.9885 69.9527 17.878 70.1556 17.6813C70.3584 17.4847 70.4723 17.2179 70.4723 16.9398V10.7948H74.1809L79.6805 16.9105C79.985 17.249 80.3609 17.5204 80.7827 17.7064C81.2045 17.8923 81.6624 17.9885 82.1258 17.9885H85.3087L78.7612 10.7906H85.3087V0H66.7627Z",
    fill: "#787777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_7969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/logo-gray.0c82b525f66e92701603162f363d2fa7.svg";
export { ForwardRef as ReactComponent };